// extracted by mini-css-extract-plugin
export var radioInputRow = "L_wC";
export var radioInputColumn = "L_wD";
export var inputOptionRow = "L_sN";
export var inputOptionColumn = "L_sP";